import { z } from 'zod'
import { productLiteCategorized } from './product'

// A coupon code has NO guaranteed length, so this is only a coarse sanity
// filter: the backend is the real validator. Nothing limits it in the DB; the
// creation form asks for 4-20 chars after a 3-char campaign prefix (e.g.
// "UKS"), so a full code is 7-23 chars (8 seen in prod).
//  - MIN: kept at the form's raw minimum (4), below the 7 the form really
//    produces, so a shorter coupon created some other way still works.
//  - MAX: 3 + 20, the longest the form allows.
// Both bare and identified coupons rely on a real QR never being a valid coupon
// code as a whole: a QR carries a capitalized name (lowercase) and a phone, so
// it is either not [A-Z0-9] only or longer than MAX. A bare coupon whose own
// characters spell 'FF99' is therefore never mistaken for a separator.
export const COUPON_CODE_MIN_LENGTH = 4
export const COUPON_CODE_MAX_LENGTH = 23
export const COUPON_CODE_REGEX = new RegExp(
  `^[A-Z0-9]{${COUPON_CODE_MIN_LENGTH},${COUPON_CODE_MAX_LENGTH}}$`
)

export const aopCheckCouponDto = z.object({
  code: z.string(),
  products: z.array(productLiteCategorized)
})
